export enum WalletPortfolioAllocationOption {
  IndividualAssets = 'Assets',
  WalletTypes = 'Wallet type',
}
